import React, {useState} from 'react';
import _ from 'lodash';
import GoogleLogin from 'react-google-login';
import Select from 'react-select';
import Calls from '../../../utils/Calls';

function NewProjectGauth({setToken, setGdomain}) {

    const [err, setErr] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [domainList, setDomainList] = useState([]);
    const [userEmail, setUserEmail] = useState(null);
    const [step, setStep] = useState(0);

    function handleLogin(gAuth){
        setIsLoading(true);
        Calls.googleRefreshToken(gAuth.code).then(resp=>{
            setStep(step+1);
            setToken(resp.refresh_token);
            getDomainList(resp.access_token);
            getUserInfo(resp.access_token);
        }).catch(error=>{
            console.error(error);
            setErr("Nastal problém s přihlášením");
        })
    }
    function handleLoginFailure(gAuth){
        try {
            throw new Error(JSON.stringify(gAuth));
        } catch (error) {
            console.error("chyba přihlašování");
        }
        setErr("Tlačítko pro přihlášení do google se nepodařilo načíst");
    }

    function getUserInfo(accessToken){
        Calls.getGoogleUserInfo(accessToken).then(data=>{
            setUserEmail(data.email);
        }).catch(err=>{
            console.error(err);
            setErr("Načtení uživatele se nezdařilo");
        })
    }

    function getDomainList(accessToken){
        Calls.gscDomainList(accessToken).then(data=>{
            if(data.siteEntry.length>0){
                let siteEntry = data.siteEntry;
                for (let i = 0; i < siteEntry.length; i++) {
                    siteEntry[i].label = siteEntry[i].siteUrl;
                    siteEntry[i].value = siteEntry[i].siteUrl;
                }
                let sorted = _.orderBy(siteEntry, "name", "asc");
                // sorted = _.filter(sorted, function(o){return (o.permissionLevel==="siteOwner"||o.permissionLevel==="siteFullUser")});
                setDomainList(sorted);
                setIsLoading(false);
            }else{
                setIsLoading(false);
                setErr("Nemáte oprávnění pro Google search console");
            }
        }).catch(err=>{
            console.error(err);
            setIsLoading(false);
            setErr("Načtení se nezdařilo");
        });
    }

    function updateDomain(domain){
        setGdomain(domain.siteUrl);
        setStep(2);
    }

    return (
        <div className="project-new-inner text-center project-new-gauth card">
            {step===1?<img className="illustration" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewGauthDomain.svg"} alt="illustration" />:
            <img className="illustration domain" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewGauth.svg"} alt="illustration" />}
            {step===1?
            <h5>Choose Search Console property</h5>
            :<h5>Autorizuj svůj Google účet</h5>}
            {step===0?<GoogleLogin
                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                    buttonText="Autorizovat účet Google"
                    scope="https://www.googleapis.com/auth/webmasters.readonly"
                    onSuccess={handleLogin}
                    onFailure={handleLoginFailure}
                    cookiePolicy={'single_host_origin'}
                    style={{display: "block"}}
                    accessType="offline"
                    responseType="code"
                    prompt="consent"
                />:step===1?
                <Select
                    className="search-select"
                    placeholder="Vyberte doménu"
                    classNamePrefix="select"
                    isDisabled={(!domainList.length>0)}
                    isLoading={isLoading}
                    isSearchable={true}
                    name="domain-selector"
                    options={domainList}
                    onChange={updateDomain}
                />:<div className="card card-border card-small-padding">
                    <p className="text-center">Logged as {userEmail}</p>
                    <button onClick={()=>setStep(0)} className="btn btn-link bold">Change account</button>
                </div>}
                {(err!==""?<p className="text-center error">{err}</p>:"")}
                {step===1?
                <div className="change">
                    <p className="text-center">
                    Logged in as {userEmail}
                    </p>
                    <button onClick={()=>setStep(0)} className="btn btn-link bold">Change account</button>
                </div>
                :<a href="https://www.keyword-eater.cz/" className="description text-center btn btn-link">Pro více informací mrkni <b>sem</b></a>}
        </div>
    );
}

export default NewProjectGauth;